import { FileSyncOutlined, LoadingOutlined } from '@ant-design/icons'
import { Dropdown, Menu, Tooltip } from 'antd'
import { useState } from 'react'

/**
 * ⚠️ Unlike the existing UploadDownloadButtons component, this component is truly dumb and is just a piece of UI
 * with a click handler. You are reponsible for handling the click event (which provides the selected format)
 * and calling the apprioate loader code to download the file.
 */
export const DownloadButtons = ({ additionalFormats = [], onDownload, isLoading, overrideOptions = null }) => {
  const downloadOptions = overrideOptions
    ? overrideOptions
    : [{ title: 'Download Excel (.xlsx)', name: 'excel' }, ...additionalFormats]
  const DownloadFormatsMenu = (
    <Menu onClick={(e) => onDownload(downloadOptions[e.key])} disabled={isLoading}>
      {downloadOptions.map((option, index) => (
        <Menu.Item key={index}>{option.title}</Menu.Item>
      ))}
    </Menu>
  )
  return (
    <Tooltip title='Work In Excel'>
      <Dropdown.Button
        overlay={DownloadFormatsMenu}
        onClick={() => onDownload(downloadOptions[0])}
        disabled={isLoading}
      >
        {isLoading ? (
          <LoadingOutlined style={{ fontSize: '1.2em' }} />
        ) : (
          <FileSyncOutlined style={{ fontSize: '1.2em' }} />
        )}
      </Dropdown.Button>
    </Tooltip>
  )
}
